import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export interface IUpdateMenuSectionRequest {
  name?: string;
  description?: string;
  items?: string[];
  instanceIds?: string[] | null;
  venueIds?: string[] | null;
}

export const updateMenuSection = async (
  menuId: string,
  sectionId: string,
  body: IUpdateMenuSectionRequest,
): Promise<Response> => {
  try {
    const res = await fetch(`${API_URL}/menus/${menuId}/sections/${sectionId}`, {
      method: 'PUT',
      body: JSON.stringify({
        name: body.name,
        description: body.description,
        items: body.items,
        extension_instance_ids: body.instanceIds,
        venue_ids: body.venueIds,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!res.ok) {
      const errorBody: { message?: string } | null = await res.json().catch(() => null);
      throw new Error(errorBody?.message || res.statusText);
    }
    return res;
  } catch (e) {
    throw new Error(e instanceof Error ? e.message : 'Could not update menu section', { cause: e });
  }
};
